import {Component} from '@angular/core';

@Component({
    selector: 'app-check-theme-section',
    templateUrl: './check-theme-section.component.html',
    styleUrls: ['./check-theme-section.component.scss'],
})
export class CheckThemeSectionComponent {
}
